import React from "react";
import { useEffect, useMemo } from "react";
import { useState } from "react";

export const EventMonth = React.memo((props) => {
    return (
        <div className="month-event-container">
            <p className="md:text-xs lg:text-sm xl:text-base xlarge:text-lg">
                {props.event.total_walk_in} In Clinic Appointments
            </p>
            <p className="md:text-xs lg:text-sm xl:text-base xlarge:text-lg">
                {props.event.total_virtual} Online Appointments
            </p>
        </div>
    );
});
